import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Gallery.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const galleryImages = [
  { src: "/assets/gallery/slide1.webp", title: "Modular OT Installation Pune" },
  { src: "/assets/gallery/img2.webp", title: "Laminar Air Flow OT System" },
  { src: "/assets/gallery/slide3.webp", title: "Operation Theatre Setup India" },
  { src: "/assets/gallery/slide2.webp", title: "Hospital OT Design WEMS" },
  { src: "/assets/gallery/img5.webp", title: "Modular OT Interior Design" },
  { src: "/assets/gallery/img6.webp", title: "Cleanroom OT System India" },
];

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const openModal = useCallback((i) => setCurrentIndex(i), []);
  const closeModal = useCallback(() => setCurrentIndex(null), []);

  return (
    <section className="gallery-page">
      <Helmet>
        <title>Modular OT Gallery | WEMS</title>
        <meta
          name="description"
          content="Modular OT installations and hospital infrastructure projects by WEMS across India."
        />
      </Helmet>

      <h1 className="gallery-title">Modular OT Gallery</h1>

      {/* MOBILE SWIPER */}
      {isMobile && (
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 2500 }}
          slidesPerView={1.1}
          centeredSlides={true}
          spaceBetween={15}
        >
          {galleryImages.map((img, i) => (
            <SwiperSlide key={i} onClick={() => openModal(i)}>
              <div className="gallery-card">
                <img
                  src={img.src}
                  alt=""
                  loading="lazy"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {/* GRID */}
      <div className="gallery-grid">
        {galleryImages.map((img, i) => (
          <div
            className="gallery-card"
            key={i}
            onClick={() => openModal(i)}
          >
            <img src={img.src} alt="" loading="lazy" />
          </div>
        ))}
      </div>

      <div className="view-all-container">
        <button
          className="view-all-button"
          onClick={() => navigate("/modular-ot-gallery")}
        >
          View All Projects
        </button>
      </div>

      {/* MODAL */}
      {currentIndex !== null && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={galleryImages[currentIndex].src}
              alt=""
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;